import { createAction, props } from '@ngrx/store'
import { TaxesActionTypeEnum, TaxesEntity } from './taxes.models'
import { HttpErrorResponse } from '@angular/common/http'

export const selectTax = createAction('[Taxes/API] Select Tax', props<{ taxUuid: string | undefined }>())

export const loadTaxes = createAction('[Taxes/API] Load Taxes')

export const loadTaxesSuccess = createAction('[Taxes/API] Load Taxes Success', props<{ taxes: TaxesEntity[] }>())

export const loadTaxesFailure = createAction('[Taxes/API] Load Taxes Failure', props<{ error: HttpErrorResponse }>())

export const loadTax = createAction('[Taxes/API] Load Tax', props<{ taxUuid: string }>())

export const loadTaxSuccess = createAction('[Taxes/API] Load Tax Success', props<{ tax: TaxesEntity }>())

export const loadTaxFailure = createAction('[Taxes/API] Load Tax Failure', props<{ error: HttpErrorResponse }>())

export const createTax = createAction(
  '[Taxes/API] Create new tax',
  props<{ tax: Partial<TaxesEntity>; applyToExistingItems?: boolean }>(),
)

export const deleteTax = createAction('[Taxes/API] Delete tax', props<{ tax: TaxesEntity }>())

export const updateTax = createAction('[Taxes/API] Update tax', props<{ tax: Partial<TaxesEntity> }>())

export const taxesChangedSuccess = createAction(
  '[Taxes/API] Taxes Changed Success',
  props<{ tax: TaxesEntity; taxActionType: TaxesActionTypeEnum }>(),
)

export const taxesChangedFailure = createAction(
  '[Taxes/API] Taxes Changed Failure',
  props<{ error: HttpErrorResponse; taxActionType: TaxesActionTypeEnum }>(),
)

export const applyTaxToAllItems = createAction(
  '[Taxes/API] Apply tax to all items',
  props<{ taxUuid: string; showConfirmation?: boolean }>(),
)

export const applyTaxToAllItemsSuccess = createAction('[Taxes/API] Apply tax to all items Success')

export const applyTaxToAllItemsFailure = createAction(
  '[Taxes/API] Apply tax to all items Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openEditTaxDialog = createAction('[Taxes/API] Open Edit Tax Dialog')

export const resetEditCreateLoaded = createAction('[Taxes/API] Reset Edit Create Loaded')

export const clearTaxes = createAction('[Taxes/Page] Clear Taxes')
